/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { getFromRangeMap, getOrAddInMap, setInRangeMap, } from "../../util/index.js";
export function addCrossFieldQuery(set, revision, id, count) {
    setInCrossFieldMap(set, revision, id, count, true);
}
export function setInCrossFieldMap(map, revision, id, count, value) {
    setInRangeMap(getOrAddInMap(map, revision, []), id, count, value);
}
export function getFirstFromCrossFieldMap(map, revision, id, count) {
    return getFromRangeMap(map.get(revision) ?? [], id, count);
}
/**
 */
export var CrossFieldTarget;
(function (CrossFieldTarget) {
    CrossFieldTarget[CrossFieldTarget["Source"] = 0] = "Source";
    CrossFieldTarget[CrossFieldTarget["Destination"] = 1] = "Destination";
})(CrossFieldTarget || (CrossFieldTarget = {}));
//# sourceMappingURL=crossFieldQueries.js.map